import React from 'react';
import { useId } from "react-id-generator";
import FormRow from 'commons/components/FormFields/FormRow';

interface InputFieldProps {
    className?: string,
    disabled?: boolean,
    fieldIcon?: any,
    error?: string,
    id?: string,
    label?: string | string[],
    name?: string,
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void,
    placeholder?: string,
    rowClassName?: string,
    touched?: boolean,
    type?: string,
}

function InputField(props: InputFieldProps) {

    const inputId = props.id ?? useId(1, "inputField-")[0];
    const inputRef = React.createRef<HTMLInputElement>();
    const inputProps = Object.assign({}, props);

    // Remove props not used by the HTML <input>
    delete inputProps.error;
    delete inputProps.fieldIcon;
    delete inputProps.rowClassName;
    delete inputProps.touched;

    return (
        <FormRow 
            className={props.rowClassName}
            disabled={props.disabled}
            fieldIcon={props.fieldIcon}
            error={props.error}
            idPrefix={props.name}
            inputId={inputId}
            label={props.label}
            renderErrorIcon={props.type != "checkbox" && props.type != "radio"}
            touched={props.touched}
            type={props.type}
        >
            <input
                {...inputProps}
                className={`input-field ${props.className ? props.className : ''}`}
                data-testid={inputId}
                disabled={props.disabled}
                id={inputId}
                placeholder={props.placeholder}
                ref={inputRef}
            />
        </FormRow>
    );

}

InputField.defaultProps = {
    disabled: false,
    touched: false,
    type: "text",
};

export default InputField;